import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Table,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  Dialog,
  DialogContent,
  Paper,
  IconButton,
  TableSortLabel
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MuiDialogTitle from '@mui/material/DialogTitle';
import BrowserFiltersComponent from './BrowserFiltersComponent';
import BrowserItemComponent from './BrowserItemComponent';
import WrappedFakeText from 'components/common/WrappedFakeText';
import PaginationWrapper from 'components/common/PaginationWrapper';

export const BrowserDialogComponent = ({
  onPropertyChange,
  loadOptions,
  browser,
  pager,
  onCloseModal,
  totalCount,
  onChangeRowsPerPage,
  onChangePage,
  selectItem,
  onRefresh,
  browserData,
  title,
  pushFilters,
  browserDataLoading,
  order,
  orderBy,
  onRequestSort
}) => {
  useEffect(() => {
    const { filters } = browser.document;
    let values = filters.map(x => ({ value: x.defaultValue, name: x.name }));
    pushFilters(values);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const createSortHandler = (property, fieldName) => _event => {
    onRequestSort(property, fieldName);
  };

  const getBrowserModal = () => {
    const { fields, labelFieldName, valueFieldName } = browser.document;
    let { document, validationInfo } = browser;
    const { filters } = document;
    validationInfo = validationInfo.filters;

    return (
      <Dialog fullWidth={true} maxWidth={'xl'} open={true} onClose={onCloseModal} aria-labelledby='browser-dialog-title'>
        <MuiDialogTitle>
          {title}
          <IconButton aria-label='Close' onClick={onCloseModal}>
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {filters &&
              filters.map((filter, idx) => (
                <Grid item xs={12} md={6} key={filter.name}>
                  <BrowserFiltersComponent
                    filter={filter}
                    validationInfo={validationInfo && validationInfo[idx]}
                    idx={idx}
                    onPropertyChange={onPropertyChange}
                    loadOptions={loadOptions}
                  />
                </Grid>
              ))}
          </Grid>

          <Paper>
            <div>
              <Table aria-labelledby='tableTitle'>
                <TableHead>
                  <TableRow selected={true}>
                    {fields &&
                      fields.map((item, idx) => {
                        return (
                          <TableCell key={idx} align={'right'} sortDirection={orderBy === idx ? order : false}>
                            <TableSortLabel active={orderBy === idx} direction={order} onClick={createSortHandler(idx, item.name)}>
                              {item.caption}
                            </TableSortLabel>
                          </TableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {browserDataLoading || !browserData || browserData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={fields.length}>
                        <WrappedFakeText lines={pager.pageSize} />
                      </TableCell>
                    </TableRow>
                  ) : (
                    browserData.map((item, idx) => {
                      return (
                        <BrowserItemComponent
                          key={idx}
                          selectItem={selectItem}
                          item={item}
                          fields={fields}
                          labelFieldName={labelFieldName}
                          valueFieldName={valueFieldName}
                        />
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </DialogContent>

        <PaginationWrapper
          count={totalCount}
          pageSize={pager.pageSize}
          page={pager.page}
          onRowsPerPageChange={onChangeRowsPerPage}
          onPageChange={onChangePage}
          onRefresh={onRefresh}
        />
      </Dialog>
    );
  };
  return getBrowserModal();
};

BrowserDialogComponent.propTypes = {
  onPropertyChange: PropTypes.func.isRequired,
  browser: PropTypes.object.isRequired,
  browserId: PropTypes.string.isRequired,
  onRefresh: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  pager: PropTypes.object.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  onChangePage: PropTypes.func.isRequired,
  selectItem: PropTypes.func.isRequired,
  browserData: PropTypes.array.isRequired,
  pushFilters: PropTypes.func.isRequired,
  browserDataLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired
};

export default BrowserDialogComponent;
